import { assign } from 'lodash';
import { initialize } from 'launchdarkly-js-client-sdk';
import { sessionManager } from 'vue-infra';
import { DATA_STATES } from '@/store/consts';
import ShellService from '@/services/shell/ShellService';
import { actions as baseActions, ACTION_TYPES as BASE_ACTION_TYPES } from '../base-collection/actions';
import { MUTATION_TYPES } from './mutations';
import { LD_ZONES_CLIENTIDS } from '../../../../common/consts';
import { STATE_KEYS } from './state';


// const logger = Logger.getLogger('workato-configuration');

const ACTION_TYPES = assign({}, BASE_ACTION_TYPES, {
  FETCH_SHELL_ITEMS: 'initShellItems',
  SET_FIRST_TIME_VISITED: 'setFirstTimeVisited',
  SET_FIRST_TIME_UNVISITED: 'setFirstTimeUnvisited',
});

const actions = assign({}, baseActions, {
  [ACTION_TYPES.FETCH_SHELL_ITEMS]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_DATA_STATE, DATA_STATES.LOADING);
    try {
      const data = await ShellService.getShellItems();
      const {
        isFirstTimeUser,
        getStartedComponents,
        onboardingComponents,
        getStartedVideoUrl,
      } = data;
      commit(MUTATION_TYPES.SET_FIRST_TIME_USER, isFirstTimeUser);
      commit(MUTATION_TYPES.SET_ONBOARDING_ITEMS, onboardingComponents);
      commit(MUTATION_TYPES.SET_STARTED_VIDEO_URL, getStartedVideoUrl);
      commit(MUTATION_TYPES.SET_ITEMS, getStartedComponents);
      commit(MUTATION_TYPES.SET_DATA_STATE, DATA_STATES.SUCCESS);
    } catch (err) {
      commit(MUTATION_TYPES.SET_DATA_STATE, DATA_STATES.ERROR);
    }
  },

  [ACTION_TYPES.SET_FIRST_TIME_VISITED]: ({ commit }) => {
    commit(MUTATION_TYPES.SET_FIRST_TIME_USER, false);
  },
  [ACTION_TYPES.SET_FIRST_TIME_UNVISITED]: ({ commit }) => {
    commit(MUTATION_TYPES.SET_FIRST_TIME_USER, true);
  },
  async [ACTION_TYPES.FETCH_FEATURE_FLAGS]({ commit, state }) {
    let featureFlags = state[STATE_KEYS.CURRENT_SERVICE];
    try {
      featureFlags = await new Promise((resolve) => {
        const zone = sessionManager.getAccountZone();
        const client = initialize(LD_ZONES_CLIENTIDS[zone] || LD_ZONES_CLIENTIDS.z0, {
          key: sessionManager.getAccountId(),
        });
        client.on('ready', () => {
          resolve(client.allFlags());
        });
      });

      commit(MUTATION_TYPES.SET_FEATURE_FLAGS, featureFlags);
    } catch (error) {
      console.error('Failed to fetch ld flags');
    }
    return featureFlags;
  },
});

export {
  actions,
  ACTION_TYPES,
};
